import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import backend from 'i18next-http-backend';
import languageDetector from 'i18next-browser-languagedetector';

i18n
    // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
    // learn more: https://github.com/i18next/i18next-http-backend
    .use(backend)
    // detect user language
    // learn more: https://github.com/i18next/i18next-browser-languageDetector
    .use(languageDetector)
    .use(initReactI18next)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
        fallbackLng: 'en',
        debug: process.env.NODE_ENV === 'development',

        interpolation: {
            escapeValue: false
        },
        load: 'languageOnly',
        backend: {
            loadPath: '/locales/{{lng}}/{{ns}}.json'
        },
        initImmediate: false
    });

export default i18n;
